import React, { useState } from 'react'
import closeModalIcon from '../assets/closeBlue.svg'
import LogoLangue from '../assets/logoLangue.svg'
import { useTranslation } from 'react-i18next'
import { France, Deutsch, English } from 'assets/drapeauxCarres'
import { updateLanguage } from 'requests/user'

interface Props {
  setIsOpen: (value: boolean) => void
}
const ModalLanguageSwitcher: React.FC<Props> = ({  setIsOpen }) => {
  const { t, i18n } = useTranslation()
  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language)
    setIsOpen(false)
  }
  const ListLanguage = [
    { code: 'fr', name: 'Français', flag: France },
    { code: 'en', name: 'English', flag: English },
    { code: 'de', name: 'Deutsch', flag: Deutsch },
  ]
  const [selectLanguage, setSelectlanguage] = useState(
    ListLanguage.find((item) => item.name === t('test.language'))?.code ?? 'fr',
  )
  return (
    <div className="items-center flex fixed  z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full">
      <div className=" gap-4 items-center w-[325px] shadow-[0px_4px_10px, rgba(0,0,0,0.25)] p-[25px] sm:p-4 rounded-2xl flex flex-col  mx-auto bg-white ">
        <img
          src={closeModalIcon}
          width={24}
          height={24}
          onClick={() => setIsOpen(false)}
          className=" self-end   justify-end hover:cursor-pointer xs:w-[18px] sm:mx-2 sm:mt-3"
        />
        <img className="mt-4" width={87} height={87} src={LogoLangue} alt="" />
        <h2 className="h2">Choisissez votre langue</h2>
        {ListLanguage.map((item, index) => (
          <div
            key={index}
            className={`${item.code === selectLanguage && ' bg-[#F1F1FF] border border-[#5754E5] rounded-[14px]'} cursor-pointer flex gap-4 items-center w-full h-[56px] px-4`}
            onClick={() => setSelectlanguage(item.code)}
          >
            <img src={item.flag} width={27} height={18} alt="" />
            <div className="text-[#5754E5] text-[14px] font-medium font-roboto">{item.name}</div>
          </div>
        ))}
        <button
          onClick={() => {
            changeLanguage(selectLanguage)
          }}
          className="buttonBlue w-full"
        >
          Enregistrer
        </button>
      </div>
    </div>
  )
}

export default ModalLanguageSwitcher
